export default __webpack_public_path__ + "static/media/bn_1.ddf6cc46.jpg";